const ListExp = [
    {
      id: "1",
      title: "Học nấu ăn trực tuyến",
      imgURL:
        "https://i.pinimg.com/564x/0b/e3/10/0be31036228a4d977a551089fe0e2157.jpg",
      tel: "0823996913",
      email: "phuvietdang@gmail.com",
      description:"In ancient manuscripts, another means to divide sentences into paragraphs was a line break (newline) followed by an initial at the beginning of the next paragraph. An initial is an oversized capital letter, sometimes outdented beyond the margin of the text.",
      cols: 2
    },
  
    {
      id: "2",
      title: "Trải nghiệm Graffiti",
      imgURL:
        "https://i.pinimg.com/236x/17/e7/f4/17e7f473a7ebd00ef482b9ddc025fc26.jpg",
      tel: "0823996913",
      email: "phuvietdang@gmail.com",
      description:"In ancient manuscripts, another means to divide sentences into paragraphs was a line break (newline) followed by an initial at the beginning of the next paragraph. An initial is an oversized capital letter, sometimes outdented beyond the margin of the text.",
      cols: 1
    },
    {
      id: "3",
      title: "Đánh lừa thị giác",
      imgURL:
        "https://i.pinimg.com/564x/59/a1/92/59a1924702275d2057f25b184f4b33bd.jpg",
      tel: "0823996913",
      email: "phuvietdang@gmail.com",
      description:"In ancient manuscripts, another means to divide sentences into paragraphs was a line break (newline) followed by an initial at the beginning of the next paragraph. An initial is an oversized capital letter, sometimes outdented beyond the margin of the text.",
      cols: 1

    },

    {
      id: "4",
      title: "Pha chế ly Cocktail của bạn",
      imgURL:
        "https://i.pinimg.com/564x/3f/ab/44/3fab44820b03d29014e282a7f04dfea4.jpg",
      tel: "0823996913",
      email: "phuvietdang@gmail.com",
      description:"In ancient manuscripts, another means to divide sentences into paragraphs was a line break (newline) followed by an initial at the beginning of the next paragraph. An initial is an oversized capital letter, sometimes outdented beyond the margin of the text.",
      cols: 1

    },
  ];
  
  export default ListExp;
  